import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createAuthSlice } from './authStore.js';
import { createSalesSlice } from './branchstore/branchSalesStore.js';
import { createUiSlice } from './uiStore.js';
import { createAdminDashboardSlice } from './adminstore/adminDashboardStore.js';
import { createAdminUsersSlice } from './adminstore/adminUsersStore.js';
import { createAdminReportsSlice } from './adminstore/adminReportsStore.js';
import { createAdminBranchesSlice } from './adminstore/adminBranchesStore.js';
import { createAdminProductReportsSlice } from './adminstore/adminProductReportsStore.js';
import { createTokenSlice } from './tokenStore.js';
import { createInventorySlice } from './branchstore/InventoryStore.js';
import { createProductSlice } from './branchstore/BranchProductStore.js';
import { createCategoriesSlice } from './branchstore/branchCategoriesStore.js';
import { createBranchSlice } from './branchStore.js';
import { branchSetupStore } from './branchstore/branchSetupStore.js';
import { createBranchDashboardSlice } from './branchstore/branchDashboardStore.js';

const useAppStore = create(devtools((set, get) => ({
  ...createAuthSlice(set, get),
  ...createSalesSlice(set, get),
  ...createUiSlice(set, get),
  admin: {
    ...createAdminDashboardSlice(set, get),
    ...createAdminUsersSlice(set, get),
    ...createAdminReportsSlice(set, get),
    ...createAdminBranchesSlice(set, get),
    ...createAdminProductReportsSlice(set, get)
  },
  ...createBranchDashboardSlice(set, get),
  ...createTokenSlice(set, get),
  ...createInventorySlice(set, get),
  ...createProductSlice(set, get),
  ...createCategoriesSlice(set, get),
  ...createBranchSlice(set, get),
  ...branchSetupStore(set, get),
})));

export default useAppStore;
